export const NavLinks = [
     {name:"Jobs", subs: [], image:"", link: "https://kigalijob.com"},
     {name:"Cars", subs: [], image:"", link:"/category/Vehicles?=a0d3db43-94f4-47d0-bf3d-2dab7abcb128"},
     {name:"Real Estate", subs: [], image:"", link:"/category/Property?=2187ea54-acbe-4bad-872f-40c4f8d14a09"},
     {name:"Marketplace", subs: [], image:"", link:"/market"},
     {name:"Services", subs: [], image:"", link:"/category/Services?=213cf0e5-453b-4d61-aded-14adcec79f37"},
     {name:"Vacation Rentals", subs: [], image:"", link:"/category/Hotels,-Restaurants-&-Travels-?=5da3442b-43dd-44c8-874d-2a5bfedfd0d0"},
     {name: "Study and work abroad", image: "", link:'/study-&-work-abroad'},
     // {name: "Trainings", image: "", link: '/category/Education?=0ae8228c-7f5d-48fd-a2dc-89cdc08b3417?=a9c2fc1c-a32a-42d9-b771-83f5c9cd4398'},
     {name: "Scholarships", image: "", link: '/trainings-&-scholarships'},
     // {name:"Advertise", subs: [], image:"", link:"/payment-plans"}
]